import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "flex flex-col items-center justify-center w-full h-full"
};
const _hoisted_2 = { class: "text-2xl font-bold text-primary-900 dark:text-gray-200" };
const _hoisted_3 = {
    key: 1,
    class: "flex flex-col px-10 py-12"
};
const _hoisted_4 = { class: "flex items-center justify-center gap-4 sm:justify-end" };
const _hoisted_5 = {
    key: 0,
    class: "flex flex-row flex-wrap-reverse justify-center mt-5 sm:w-2/3"
};
const _hoisted_6 = { class: "flex flex-row flex-wrap items-center justify-around sm:ml-10" };
const _hoisted_7 = { class: "flex flex-col content-start" };
const _hoisted_8 = { class: "text-4xl font-bold text-primary-900 dark:text-white" };
const _hoisted_9 = { class: "text-sm font-normal sm:w-80 text-primary-900 dark:text-white" };
const _hoisted_10 = { class: "flex" };
const _hoisted_11 = ["src"];
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M168.66 213.223h21.33M172.368 223.302l36.632-.006",
    stroke: "#F7F7FF",
    "stroke-width": "17.279",
    "stroke-linecap": "round"
}, null, -1);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M111.74 199.279a8.487 8.487 0 019.273-7.133l4.59.482c6.97.733 12.026 6.976 11.293 13.946l-.442 4.206a4.23 4.23 0 108.413.885l.442-4.207c.733-6.969 6.976-12.025 13.946-11.293l4.59.483a8.487 8.487 0 017.587 8.905l-3.706 67.6c-.265 4.847-4.534 8.484-9.361 7.976l-49.556-5.208c-4.828-.508-8.247-4.953-7.499-9.749l10.43-66.893z",
    fill: "#FF7645"
}, null, -1);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M134.104 231.887a.792.792 0 011.116-.104 5.527 5.527 0 002.959 1.243 5.537 5.537 0 003.128-.603.792.792 0 11.729 1.408 7.114 7.114 0 01-4.023.772 7.111 7.111 0 01-3.805-1.599.793.793 0 01-.104-1.117z",
    fill: "#00292B"
}, null, -1);
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("circle", {
    cx: "132.914",
    cy: "224.23",
    transform: "rotate(6 132.914 224.23)",
    fill: "#00292B",
    r: "1.057"
}, null, -1);
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("circle", {
    cx: "145.533",
    cy: "225.556",
    transform: "rotate(6 145.533 225.556)",
    fill: "#00292B",
    r: "1.057"
}, null, -1);
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M50.224 197.478a9.294 9.294 0 015.636-11.1l2.403-.924a6.438 6.438 0 018.047 3.088c.816 1.818 3.508 1.413 3.752-.565l.162-1.314.05-.403a10.211 10.211 0 018.89-8.885l.642-.079a9.364 9.364 0 019.796 5.722l1.327 3.139c.715 1.693 3.2 1.395 3.495-.418a6.65 6.65 0 017.33-5.535l2.474.287a9.258 9.258 0 018.188 9.379l-.487 24.678c-.276 13.99-10.797 25.648-24.685 27.353-13.889 1.706-26.918-7.061-30.57-20.569l-6.45-23.854z",
    fill: "#FFD220"
}, null, -1);
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M97.347 202.149a6.345 6.345 0 01-12.517 2.079l12.517-2.079z",
    fill: "#00292B",
    stroke: "#00292B",
    "stroke-width": "1.591",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
}, null, -1);
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M82.517 199.854l-.045-.272v0a1.651 1.651 0 011.358-1.899v0c.9-.149 1.75.459 1.899 1.358v0l.045.272M95 197.78l-.045-.271v0a1.651 1.651 0 011.358-1.899v0c.9-.149 1.75.459 1.899 1.358v0l.045.271",
    stroke: "#00292B",
    "stroke-width": "1.591",
    "stroke-linecap": "round"
}, null, -1);
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M75.493 161.105a8.487 8.487 0 011.246-11.466l37.32-32.443a8.488 8.488 0 0111.974.838l32.442 37.32a8.487 8.487 0 01-.362 11.528l-16.38 16.61a16.976 16.976 0 01-13.271 5.014l-26.616-1.861a16.976 16.976 0 01-12.443-6.812l-13.91-18.728z",
    fill: "#E8F679"
}, null, -1);
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M112.651 138.813a2.285 2.285 0 002.44-2.121.76.76 0 00-1.511-.179l-.009.073a.762.762 0 01-1.522-.033l.002-.074a.763.763 0 00-1.521-.106 2.286 2.286 0 002.121 2.44zM124.815 139.664a2.287 2.287 0 002.44-2.121.762.762 0 00-1.512-.18l-.009.073a.76.76 0 01-1.522-.032l.002-.074a.762.762 0 10-1.521-.106 2.287 2.287 0 002.122 2.44zM122.293 144.834a.761.761 0 111.06 1.095 6.845 6.845 0 01-5.252 1.923 6.845 6.845 0 01-4.939-2.634.763.763 0 011.204-.936 5.316 5.316 0 003.841 2.05 5.323 5.323 0 004.086-1.498z",
    fill: "#00292B"
}, null, -1);
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M94.648 115.785c0 31.722 4.494 37.802 7.402 47.583 2.908 9.78 0 14.274 0 30.135 0 15.861 8.459 26.171 8.459 43.089v43.353",
    stroke: "#ACAAC3",
    "stroke-width": "1.591",
    "stroke-linecap": "round"
}, null, -1);
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M100.01 151.586c-1.325-3.279-4.085-3.937-6.265-2.991-.464.202-.627.751-.438 1.22l3.078 7.617c.204.506.763.783 1.258.554 2.127-.985 3.674-3.165 2.367-6.4z",
    fill: "#E8F679"
}, null, -1);
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M100.01 151.586c-1.325-3.279-4.085-3.937-6.265-2.991-.464.202-.627.751-.438 1.22l3.078 7.617c.204.506.763.783 1.258.554 2.127-.985 3.674-3.165 2.367-6.4z",
    fill: "#fff",
    "fill-opacity": ".3"
}, null, -1);
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M101.671 206.553c-.492-3.502 1.569-5.452 3.93-5.722.502-.058.919.336.989.837l1.143 8.135c.076.54-.269 1.06-.812 1.109-2.335.211-4.765-.904-5.25-4.359z",
    fill: "#FFD220"
}, null, -1);
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M101.671 206.553c-.492-3.502 1.569-5.452 3.93-5.722.502-.058.919.336.989.837l1.143 8.135c.076.54-.269 1.06-.812 1.109-2.335.211-4.765-.904-5.25-4.359z",
    fill: "#fff",
    "fill-opacity": ".3"
}, null, -1);
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M49.48 218.851c-1.093-3.363.598-5.642 2.876-6.318.485-.144.964.172 1.12.653l2.539 7.813c.168.518-.082 1.09-.608 1.233-2.263.613-4.85-.063-5.927-3.381z",
    fill: "#FFD220"
}, null, -1);
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M49.48 218.851c-1.093-3.363.598-5.642 2.876-6.318.485-.144.964.172 1.12.653l2.539 7.813c.168.518-.082 1.09-.608 1.233-2.263.613-4.85-.063-5.927-3.381z",
    fill: "#fff",
    "fill-opacity": ".3"
}, null, -1);
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M112.21 238.261c-.123-3.534-2.492-5.097-4.864-4.953-.504.03-.846.491-.829.996l.287 8.21c.019.545.45.997.993.951 2.336-.198 4.535-1.718 4.413-5.204z",
    fill: "#FF7645"
}, null, -1);
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M112.21 238.261c-.123-3.534-2.492-5.097-4.864-4.953-.504.03-.846.491-.829.996l.287 8.21c.019.545.45.997.993.951 2.336-.198 4.535-1.718 4.413-5.204z",
    fill: "#fff",
    "fill-opacity": ".3"
}, null, -1);
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M177.566 238.274c-.124-3.534-2.492-5.097-4.864-4.953-.505.03-.847.491-.829.996l.286 8.211c.019.544.45.996.993.95 2.336-.198 4.535-1.718 4.414-5.204z",
    fill: "#FF7645"
}, null, -1);
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M177.566 238.274c-.124-3.534-2.492-5.097-4.864-4.953-.505.03-.847.491-.829.996l.286 8.211c.019.544.45.996.993.95 2.336-.198 4.535-1.718 4.414-5.204z",
    fill: "#fff",
    "fill-opacity": ".3"
}, null, -1);
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M89.176 125.799l1.243-7.106 2.064-17.129c.136-1.128 1.71-1.278 2.057-.196l4.844 15.137c.015.049.027.098.036.148l.838 5.032c.14.841-.897 1.35-1.477.726-.531-.572-1.489-.196-1.489.585v2.41c0 .852-.954 1.354-1.656.871l-1.827-1.256a1.058 1.058 0 00-1.368.146l-1.455 1.54c-.72.763-1.991.125-1.81-.908z",
    fill: "#67D1E1"
}, null, -1);
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M139.06 59.743c0 32.995-20.949 59.743-46.79 59.743-25.841 0-46.79-26.748-46.79-59.743C45.48 26.748 66.429 0 92.27 0c25.841 0 46.79 26.748 46.79 59.743z",
    fill: "#67D1E1"
}, null, -1);
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("g", {
    "clip-path": "url(#clip0_866_5828)",
    fill: "#00292B"
}, [
    /*#__PURE__*/ _createElementVNode("path", { d: "M85.27 57.98a1.567 1.567 0 012.165-.433 10.912 10.912 0 006.049 1.815c2.139 0 4.208-.64 6-1.815a1.566 1.566 0 012.163.443c.475.717.275 1.68-.445 2.152-2.294 1.502-4.957 2.326-7.718 2.326-2.805 0-5.492-.82-7.78-2.335a1.548 1.548 0 01-.434-2.154z" }),
    /*#__PURE__*/ _createElementVNode("ellipse", {
        cx: "81.366",
        cy: "43.309",
        rx: "2.082",
        ry: "2.071"
    }),
    /*#__PURE__*/ _createElementVNode("ellipse", {
        cx: "106.347",
        cy: "43.309",
        rx: "2.082",
        ry: "2.071"
    })
], -1);
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M21.153 127.045h21.33M9 137.125l36.632-.007",
    stroke: "#F7F7FF",
    "stroke-width": "17.279",
    "stroke-linecap": "round"
}, null, -1);
const _hoisted_37 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M160.824 147.574c-2.386-2.61-5.202-2.263-6.914-.616-.365.351-.326.923.015 1.296l5.542 6.064c.368.402.989.467 1.373.08 1.649-1.665 2.338-4.249-.016-6.824z",
    fill: "#E8F679"
}, null, -1);
const _hoisted_38 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M160.824 147.574c-2.386-2.61-5.202-2.263-6.914-.616-.365.351-.326.923.015 1.296l5.542 6.064c.368.402.989.467 1.373.08 1.649-1.665 2.338-4.249-.016-6.824z",
    fill: "#fff",
    "fill-opacity": ".3"
}, null, -1);
const _hoisted_39 = /*#__PURE__*/ _createElementVNode("defs", null, [
    /*#__PURE__*/ _createElementVNode("clipPath", { id: "clip0_866_5828" }, [
        /*#__PURE__*/ _createElementVNode("path", {
            fill: "#fff",
            transform: "translate(77.202 41.238)",
            d: "M0 0h33.308v24.849H0z"
        })
    ])
], -1);
const _hoisted_40 = [
    _hoisted_12,
    _hoisted_13,
    _hoisted_14,
    _hoisted_15,
    _hoisted_16,
    _hoisted_17,
    _hoisted_18,
    _hoisted_19,
    _hoisted_20,
    _hoisted_21,
    _hoisted_22,
    _hoisted_23,
    _hoisted_24,
    _hoisted_25,
    _hoisted_26,
    _hoisted_27,
    _hoisted_28,
    _hoisted_29,
    _hoisted_30,
    _hoisted_31,
    _hoisted_32,
    _hoisted_33,
    _hoisted_34,
    _hoisted_35,
    _hoisted_36,
    _hoisted_37,
    _hoisted_38,
    _hoisted_39
];
const _hoisted_41 = { class: "flex justify-between h-8 mt-10 sm:mt-0" };
const _hoisted_42 = { class: "text-2xl font-bold text-primary-900 dark:text-white" };
const _hoisted_43 = {
    key: 0,
    class: "w-full table-fixed sm:mt-11"
};
const _hoisted_44 = { class: "h-12 font-bold border-b border-gray-200 text-primary-900 dark:text-gray-300 dark:border-gray-700" };
const _hoisted_45 = { class: "text-sm-but-a-bit-smaller" };
const _hoisted_46 = {
    key: 0,
    class: "flex justify-end mr-4"
};
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('views.teams.archived')
};
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useWorkspace } from '@/composables/workspaces';
import { useFullWidth } from '@/composables/useFullWidth';
import AvatarList from '@/components/users/AvatarList.vue';
import NoResults from '@/components/NoResults.vue';
import Scaffold from '@/components/Scaffold.vue';
import WorkspaceSubheader from '@/components/workspaces/WorkspaceSubheader.vue';
import PricingModal from '@/components/pricing/PricingModal.vue';
import { FEATURE_FLAGS } from '@/constants';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'ArchivedTeams',
    setup(__props) {
        useFullWidth();
        const { workspace } = useWorkspace();
        const store = useStore();
        const searchQuery = ref('');
        const userId = computed(() => store.getters.session.id);
        const teams = computed(() => workspace.value?.teams || []);
        const isWorkspaceFree = computed(() => store.getters.isFreeWorkspace);
        const isWorkspaceOwner = computed(() => store.getters.isWorkspaceOwner);
        const isPricingModalOpen = ref(false);
        const selectedPaymentPeriod = ref('annual');
        const isLoading = ref(false);
        const isPricingEnabled = FEATURE_FLAGS.PRICING_ENABLED;
        const handleUpgradeNow = () => {
            isPricingModalOpen.value = true;
        };
        async function handlePlanChoice(plan) {
            const paymentPeriod = plan === 'free' ? null : selectedPaymentPeriod.value;
            try {
                isLoading.value = true;
                await store.dispatch('changePlan', { plan, paymentPeriod });
                isLoading.value = false;
                isPricingModalOpen.value = false;
                store.dispatch('flashThenClear', { message: 'plan_changed' });
            }
            catch (error) {
                store.dispatch('flashThenClear', { message: 'workspace_update_failure' });
            }
        }
        const processedTeams = computed(() => {
            const search = searchQuery.value.toLowerCase();
            return teams.value
                .filter((team) => team.archivedAt)
                .filter((team) => team.name.toLowerCase().includes(search))
                .sort((t1, t2) => {
                if (canUnarchiveTeam(t1) && !canUnarchiveTeam(t2)) {
                    return -1;
                }
                if (!canUnarchiveTeam(t1) && canUnarchiveTeam(t2)) {
                    return 1;
                }
                const d1 = new Date(t1.archivedAt);
                const d2 = new Date(t2.archivedAt);
                return d2.getTime() - d1.getTime();
            });
        });
        const isViewVisible = computed(() => workspace.value);
        function handleUnarchiveTeam(team) {
            store.dispatch('updateTeam', {
                teamId: team.id,
                workspaceId: workspace.value.id,
                archived: false
            });
        }
        function canUnarchiveTeam(team) {
            return !!team.members.find((m) => m.id === userId.value);
        }
        return (_ctx, _cache) => {
            const _component_SearchInput = _resolveComponent("SearchInput");
            const _component_PillButton = _resolveComponent("PillButton");
            const _component_transition_a11y = _resolveComponent("transition-a11y");
            return (_openBlock(), _createElementBlock("div", null, [
                (_unref(isViewVisible))
                    ? (_openBlock(), _createBlock(Scaffold, {
                        key: 0,
                        class: "h-screen pt-10"
                    }, {
                        subheader: _withCtx(() => [
                            _createVNode(WorkspaceSubheader)
                        ]),
                        content: _withCtx(() => [
                            (searchQuery.value === '' && _unref(processedTeams).length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('no_archived_teams')), 1)
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createVNode(_component_SearchInput, {
                                            search: searchQuery.value,
                                            "onUpdate:search": _cache[0] || (_cache[0] = ($event) => ((searchQuery).value = $event))
                                        }, null, 8, ["search"])
                                    ]),
                                    (_unref(isPricingEnabled) && _unref(isWorkspaceFree))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                            _createElementVNode("div", _hoisted_6, [
                                                _createElementVNode("div", _hoisted_7, [
                                                    _createElementVNode("div", null, [
                                                        _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.$t('unarchive_teams')), 1)
                                                    ]),
                                                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('retroally_starter')), 1)
                                                ]),
                                                (_unref(isWorkspaceOwner))
                                                    ? (_openBlock(), _createBlock(_component_PillButton, {
                                                        key: 0,
                                                        class: "flex content-start h-8 mt-4",
                                                        onClick: handleUpgradeNow
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.$t('upgrade_button')), 1)
                                                        ], undefined, true),
                                                        _: 1
                                                    }))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_10, [
                                                (_openBlock(), _createElementBlock("svg", {
                                                    width: "218",
                                                    height: "283",
                                                    viewBox: "0 0 218 283",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    src: '@/assets/images/balloon-dudes.svg',
                                                    "svg-inline": '',
                                                    class: _normalizeClass('h-31 w-30')
                                                }, _hoisted_40, 8, _hoisted_11))
                                            ]),
                                            _createVNode(PricingModal, {
                                                "is-open": isPricingModalOpen.value,
                                                "onUpdate:is-open": _cache[1] || (_cache[1] = ($event) => ((isPricingModalOpen).value = $event)),
                                                "payment-period": selectedPaymentPeriod.value,
                                                "onUpdate:payment-period": _cache[2] || (_cache[2] = ($event) => ((selectedPaymentPeriod).value = $event)),
                                                loading: isLoading.value,
                                                class: "z-10",
                                                onChoice: handlePlanChoice
                                            }, null, 8, ["is-open", "payment-period", "loading"])
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_41, [
                                        _createElementVNode("h1", _hoisted_42, _toDisplayString(_ctx.$t('title')), 1)
                                    ]),
                                    _createVNode(_component_transition_a11y, { class: "flex-1" }, {
                                        default: _withCtx(() => [
                                            (_unref(processedTeams).length > 0)
                                                ? (_openBlock(), _createElementBlock("table", _hoisted_43, [
                                                    _createElementVNode("thead", null, [
                                                        _createElementVNode("tr", _hoisted_44, [
                                                            _createElementVNode("td", null, _toDisplayString(_ctx.$t('team_name')), 1),
                                                            _createElementVNode("td", null, _toDisplayString(_ctx.$t('teammates')), 1)
                                                        ])
                                                    ]),
                                                    _createElementVNode("tbody", _hoisted_45, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(processedTeams), (team) => {
                                                            return (_openBlock(), _createElementBlock("tr", {
                                                                key: team.id,
                                                                class: "h-12 border-b border-gray-200 text-primary-900 dark:text-gray-300 dark:border-gray-700"
                                                            }, [
                                                                _createElementVNode("td", null, _toDisplayString(team.name), 1),
                                                                _createElementVNode("td", null, [
                                                                    _createVNode(AvatarList, {
                                                                        users: team.members,
                                                                        invitations: team.invitations,
                                                                        size: "sm"
                                                                    }, null, 8, ["users", "invitations"])
                                                                ]),
                                                                _createElementVNode("td", null, [
                                                                    (_unref(isPricingEnabled)
                                                                        ? !_unref(isWorkspaceFree) && canUnarchiveTeam(team)
                                                                        : canUnarchiveTeam(team))
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                                                            _createVNode(_component_PillButton, {
                                                                                kind: "secondary",
                                                                                onClick: ($event) => (handleUnarchiveTeam(team))
                                                                            }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(_ctx.$t('unarchive_team')), 1)
                                                                                ], undefined, true),
                                                                                _: 2
                                                                            }, 1032, ["onClick"])
                                                                        ]))
                                                                        : _createCommentVNode("", true)
                                                                ])
                                                            ]));
                                                        }), 128))
                                                    ])
                                                ]))
                                                : (_openBlock(), _createBlock(NoResults, {
                                                    key: 1,
                                                    query: searchQuery.value,
                                                    "search-by": _ctx.$t('search_by')
                                                }, null, 8, ["query", "search-by"]))
                                        ], undefined, true),
                                        _: 1
                                    })
                                ]))
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
